export default "__VITE_ASSET__eco4LbQo__"